var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _StatsAdapter_globalProps, _StatsAdapter_lastUserId;
import { sendStatsService } from '@resources/js/services/stats.service';
export class StatsAdapter {
    constructor() {
        this.name = 'Stats';
        _StatsAdapter_globalProps.set(this, {});
        _StatsAdapter_lastUserId.set(this, null);
    }
    async init() {
        try {
            const stored = localStorage.getItem('stats_global_props');
            if (stored) {
                __classPrivateFieldSet(this, _StatsAdapter_globalProps, Object.assign(Object.assign({}, JSON.parse(stored)), __classPrivateFieldGet(this, _StatsAdapter_globalProps, "f")), "f");
            }
        }
        catch (_a) { }
        return true;
    }
    sendEvent(action, data) {
        var _a, _b, _c, _d, _e, _f;
        try {
            const merged = Object.assign(Object.assign({}, __classPrivateFieldGet(this, _StatsAdapter_globalProps, "f")), data);
            const { category, type, customLabelString, logId: id = (_d = (_c = (_b = (_a = window.shared) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.log) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : null } = merged, additionalParams = __rest(merged, ["category", "type", "customLabelString", "logId"]);
            const additionalParamsString = Object.keys(additionalParams).length > 0
                ? JSON.stringify(additionalParams)
                : 'null';
            const labelString = customLabelString !== null && customLabelString !== void 0 ? customLabelString : `${type}||${id}||${(_e = window === null || window === void 0 ? void 0 : window.location) === null || _e === void 0 ? void 0 : _e.origin}||${additionalParamsString}`;
            sendStatsService({
                id,
                c: category,
                a: action,
                l: labelString,
            });
            return true;
        }
        catch (error) {
            (_f = window.shared) === null || _f === void 0 ? void 0 : _f.sendError(error);
            console.error('[Analytics:Stats] Failed to send event:', error);
            return false;
        }
    }
    addGlobalProperties(properties) {
        var _a;
        try {
            const existingProps = JSON.parse(localStorage.getItem('stats_global_props') || '{}');
            localStorage.setItem('stats_global_props', JSON.stringify(Object.assign(Object.assign({}, existingProps), properties)));
            __classPrivateFieldSet(this, _StatsAdapter_globalProps, Object.assign(Object.assign({}, __classPrivateFieldGet(this, _StatsAdapter_globalProps, "f")), properties), "f");
            return true;
        }
        catch (error) {
            (_a = window.shared) === null || _a === void 0 ? void 0 : _a.sendError(error);
            return false;
        }
    }
    checkUserChanged() {
        var _a, _b, _c, _d;
        const currentUserId = (_d = (_c = (_b = (_a = window.shared) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.log) === null || _c === void 0 ? void 0 : _c.wsl) !== null && _d !== void 0 ? _d : null;
        if (!currentUserId)
            return false;
        const hasChanged = __classPrivateFieldGet(this, _StatsAdapter_lastUserId, "f") !== null && __classPrivateFieldGet(this, _StatsAdapter_lastUserId, "f") !== currentUserId;
        __classPrivateFieldSet(this, _StatsAdapter_lastUserId, currentUserId, "f");
        return hasChanged;
    }
    destroy() {
        __classPrivateFieldSet(this, _StatsAdapter_globalProps, {}, "f");
        __classPrivateFieldSet(this, _StatsAdapter_lastUserId, null, "f");
        localStorage.removeItem('stats_global_props');
    }
}
_StatsAdapter_globalProps = new WeakMap(), _StatsAdapter_lastUserId = new WeakMap();
